import {Solution, SupportCase} from '../../store/supportCaseStore';
import {Paragraph} from '@toppy-webshop/toppy-design-system';

const mapUniqueSolutions = (
    supportCase: SupportCase
): Array<
    Solution & {
        items: string[];
    }
> => {
    const solutionsItems: Record<
        string,
        Solution & {
            items: string[];
        }
    > = {};

    for (const item of supportCase.items) {
        if (typeof item.solution === 'undefined') {
            continue;
        }

        if (
            typeof solutionsItems[item.solution.id.toString()] === 'undefined'
        ) {
            solutionsItems[item.solution.id.toString()] = {
                ...item.solution,
                items: [],
            };
        }

        solutionsItems[item.solution.id.toString()].items.push(
            item.identifier.value
        );
    }

    return Object.values(solutionsItems);
};

const SolutionExplanation = ({solution}: {solution: Solution}) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                marginBottom: '1rem',
            }}
        >
            <Paragraph preWrap size="s">
                {solution.type.explanation}
            </Paragraph>
            <Paragraph preWrap size="s">
                {solution.explanation}
            </Paragraph>
        </div>
    );
};

const SupportCaseExplanation = ({supportCase}: {supportCase: SupportCase}) => {
    if (supportCase.solution) {
        return <SolutionExplanation solution={supportCase.solution} />;
    }

    const solutionsItems = mapUniqueSolutions(supportCase);

    if (Object.keys(solutionsItems).length === 1) {
        return <SolutionExplanation solution={solutionsItems[0]} />;
    }

    return (
        <>
            {solutionsItems.map(solution => {
                return <SolutionExplanation solution={solution} />;
            })}
        </>
    );
};

export default SupportCaseExplanation;
